// Resolve the assessment mode without an in-app choice: a per-link URL param wins,
// then the build-time frontend env. `null` means "let the user choose" (chooser).
// The backend can still hard-lock via ASSESSMENT_MODE regardless of this.

import { hashParams } from './persistence.js';
import type { AssessmentMode } from './types.js';

function coerce(value: string | null | undefined): AssessmentMode | null {
  return value === 'evaluate' || value === 'discover' ? value : null;
}

export function resolveMode(): AssessmentMode | null {
  try {
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get('mode') ?? hashParams(url).get('mode');
    if (coerce(fromUrl)) return coerce(fromUrl);
  } catch {
    /* ignore malformed URL */
  }
  return coerce(import.meta.env.VITE_ASSESSMENT_MODE as string | undefined);
}
